// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [
        {
            name: 'listCaseReportTemplate',
        },
    ],
    name: 'get-report-templates',
});

interface ComputeGetSelector {
    reportTemplateId: string;
}

export const computeGetSelector = ({ reportTemplateId }: ComputeGetSelector): QuerySelector => ({
    head: [
        {
            name: 'getCaseReportTemplate',
            idOrName: reportTemplateId,
        },
    ],
    name: `get-report-template-${reportTemplateId}`,
});
